import { render, staticRenderFns } from "./VoterIdentifier.vue?vue&type=template&id=0242ada4&"
import script from "./VoterIdentifier.vue?vue&type=script&lang=js&"
export * from "./VoterIdentifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports